import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
import { DEFAULT_SPACE_SETTING } from '../constants';
let SpaceSettingModelImpl = class SpaceSettingModelImpl {
    constructor() {
        this._spaceSetting = proxy(null);
    }
    get spaceSetting() {
        return this._spaceSetting.value;
    }
    updateSpaceSetting(spaceSetting) {
        this._spaceSetting.value = {
            ...DEFAULT_SPACE_SETTING,
            ...this.spaceSetting,
            ...spaceSetting,
        };
    }
    updateSpaceSettingLanguage(language) {
        this._spaceSetting.value.language = language;
    }
    clearSpaceSetting() {
        this._spaceSetting.value = {
            ...DEFAULT_SPACE_SETTING,
        };
    }
    subscribeSpaceSetting(callback) {
        const dispose = subscribe(() => this._spaceSetting.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
SpaceSettingModelImpl = __decorate([
    injectable()
], SpaceSettingModelImpl);
export { SpaceSettingModelImpl };
